"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const isEqual_js_1 = tslib_1.__importDefault(require("lodash-es/isEqual.js"));
const useDeepCompareMemoize = (value) => {
    const ref = React.useRef(value);
    if (!(0, isEqual_js_1.default)(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
};
exports.default = useDeepCompareMemoize;
//# sourceMappingURL=useDeepCompareMemoize.js.map